import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-attachment2-icon',
  templateUrl: './general-attachment2.component.html'
})
export class GeneralAttachment2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
